import {
  useFeatureFlag,
  useSessionStorage,
} from '@spotify/confidence-core-react';
import { useCheckResourcePermissions } from '@spotify/plugin-confidence-permissions-react';

// TODO: move to a backend-persisted account setting when enabling for more customers
const STORAGE_KEY = 'confidence:advancedWarehouseMode:v1';

export const useIsMultiWarehouseEnabled = (): boolean =>
  useFeatureFlag('multi-wh-frontend.enabled', false);

export const useAdvancedWarehouseMode = (): readonly [
  boolean,
  (value: boolean) => void,
] => {
  const isMultiWarehouseEnabled = useIsMultiWarehouseEnabled();
  const { allowed: canEditWarehouse } = useCheckResourcePermissions({
    name: 'account',
    can: 'edit_data_warehouse',
  });
  const [isStored, setStored] = useSessionStorage<boolean>(STORAGE_KEY, false);

  const isEnabled = isMultiWarehouseEnabled && canEditWarehouse && isStored;

  return [isEnabled, setStored] as const;
};
